// extracted by css-extract-rspack-plugin
export default {"card":"u0J7W","cardSelected":"fSVrb","colorBar":"yp04I","colorSegment":"V7bfV"};